import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { Message, MessageBox, Loading, Notification } from "element-ui";
import "./assets/icon/iconfont.css";

Vue.config.productionTip = false;

// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);
// van-datetime-picker

import {
  TreeSelect,
  Col,
  Row,
  RadioGroup,
  Radio,
  Cell,
  Cascader,
  Button,
  NavBar,
  Icon,
  Field,
  Loading as VantLoading,
  Popup,
  Image,
  Divider,
  CellGroup,
  Overlay,
  Step,
  Steps,
  Tab, 
  Tabs
} from "vant";

Vue.use(Button);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(Field);
Vue.use(VantLoading);
Vue.use(Popup);
Vue.use(Image);
Vue.use(Divider);
Vue.use(CellGroup);
Vue.use(Cascader);
Vue.use(Cell);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Overlay);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Col);
Vue.use(Row);
Vue.use(TreeSelect);
Vue.use(Tab);
Vue.use(Tabs);

Vue.use(Loading);
Vue.prototype.$loading = Loading.service;
// Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
